import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
// import { settingsLayoutComponents } from '~/pages/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const FranceConnectRoute: RouteRecordRaw = {
	name: RouteKeys.FRANCE_CONNECT,
	path: 'france-connect',
	components: {
		default: () => import('./ui/pages/FranceConnectPage.vue')
	},
	meta: {
		label: 'france_connect.navigation',
		icon: () => $i('link'),
		requiresAuth: true,
		requireFranceConnect: true,
		isSettingsNavEntry: true,
		isSubEntry: false,
		order: 1
	}
};
